var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/generated-form-dialog.ts
import "@adornis/base/utilTypes.js";
import "@adornis/baseql/entities/adornisEntity.js";
import { MongoEntity } from "@adornis/baseql/entities/mongoEntity.js";
import "@adornis/chemistry/chemistry-lit-element.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import "@adornis/chemistry/renderable.js";
import { XDialog } from "@adornis/dialog/x-dialog.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import "./generated-form.js";
import { GenericFieldFormController } from "./generic-field-formcontroller.js";
var GeneratedFormDialog = class extends XDialog {
  static get element_name() {
    return "generated-form-dialog";
  }
  // TODO revert document on cancel
  // TODO think of a better way to pass options to generated form. Maybe with an options object like in data-view
  /**
   * Opens a dialog which contains a `generated-form` to edit `entity`. Returns the entity which is also edited in place. Handles validation errors.
   *
   * - black and whitelist include / exclude fields to be shown
   * - persist will attempt to `.save` or `.create` if the passed entity is a `MongoEntity`
   * - columns is passed to `generated-form`
   * - extraContent is slotted into the `generated-form`
   *
   * @returns the entity that you have passed to edit
   */
  static async edit(entity, {
    blacklist = [],
    whitelist = [],
    columns = 1,
    extraContent = void 0,
    persist = void 0
  } = {}) {
    return this.showPopup({
      content: (resolve, reject, el) => {
        const fc = new GenericFieldFormController(el, entity, {
          success: async (e) => {
            if (persist) {
              if (!(e instanceof MongoEntity))
                throw new Error("can only persist MongoEntities");
              await XDialog.guard(() => persist === "create" ? e.create() : e.save());
            }
            resolve(e);
          },
          error: (e) => XSnackbar.show(`Fehler: ${e.message}`)
        });
        return html`
          <x-flex padding="md" space="md">
            <generated-form
              .blacklist=${blacklist}
              .whitelist=${whitelist}
              .columns=${columns}
              controls
              .formController=${fc}
              @cancel=${() => reject()}
            >
              ${extraContent?.(fc, el)}
            </generated-form>
          </x-flex>
        `;
      }
    });
  }
};
GeneratedFormDialog = __decorateClass([
  customElement("generated-form-dialog")
], GeneratedFormDialog);
export {
  GeneratedFormDialog
};
